var React = require('react');

function ChevronLeft (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M8.36 17.39L.33 8.7 8.36 0l1.98 1.83L4 8.7l6.34 6.86-1.98 1.83z"}));
}

ChevronLeft.defaultProps = {"width":"10.67","height":"17.39","viewBox":"0 0 10.67 17.39"};

module.exports = ChevronLeft;

ChevronLeft.default = ChevronLeft;
